import { render, staticRenderFns } from "./OrganizationConfigIntegrations.vue?vue&type=template&id=158dd830&scoped=true&"
import script from "./OrganizationConfigIntegrations.vue?vue&type=script&lang=js&"
export * from "./OrganizationConfigIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationConfigIntegrations.vue?vue&type=style&index=0&id=158dd830&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158dd830",
  null
  
)

export default component.exports